const TOKEN_KEY = '@CondomobWeb:tokenFireBase';

export const onSignIn = (value) => localStorage.setItem(TOKEN_KEY, value)

export const onSignOut = () => {
    localStorage.removeItem(TOKEN_KEY);
};

export const GetToken = () => localStorage.getItem(TOKEN_KEY);
